<template>
  <section id="contacto" class="rf-contacto">
    <div class="rf-contacto-inner">
      <div>
        <span class="rf-eyebrow">Contacto</span>
        <h2>Construye un<br>futuro más seguro</h2>
        <p class="rf-cuerpo">
          Una inversión en activos tangibles y recursos naturales en una de las regiones más
          estables y ricas en biodiversidad del planeta. Si estás interesado, envíanos tus datos y
          nos pondremos en contacto contigo.
        </p>
        <div class="rf-contacto-ilus">
          <img :src="`${ASSETS}/illustration-deer.png`" alt="Ilustración ciervo en paisaje austral">
        </div>
      </div>

      <div>
        <p v-if="enviado" class="rf-contacto-ok">
          Gracias, {{ enviado }}. Recibimos tu solicitud y te contactaremos pronto.
        </p>
        <form v-else novalidate @submit.prevent="enviar">
          <div class="rf-form-group">
            <label class="rf-form-label" for="rf-nombre">Nombre</label>
            <input
              id="rf-nombre"
              v-model="form.nombre"
              type="text"
              class="rf-form-input"
              placeholder="Ingresa tu nombre completo"
            >
            <p v-if="errores.nombre" class="rf-form-error">{{ errores.nombre }}</p>
          </div>
          <div class="rf-form-group">
            <label class="rf-form-label" for="rf-correo">Correo</label>
            <input
              id="rf-correo"
              v-model="form.correo"
              type="email"
              class="rf-form-input"
              placeholder="Ingresa tu correo electrónico"
            >
            <p v-if="errores.correo" class="rf-form-error">{{ errores.correo }}</p>
          </div>
          <div class="rf-form-group">
            <label class="rf-form-label" for="rf-telefono">Teléfono</label>
            <input
              id="rf-telefono"
              v-model="form.telefono"
              type="tel"
              class="rf-form-input"
              placeholder="Ingresa tu número de teléfono"
            >
          </div>
          <div class="rf-form-group">
            <label class="rf-form-label" for="rf-proyecto">Proyecto de interés</label>
            <div class="rf-select">
              <select id="rf-proyecto" v-model="form.proyecto" class="rf-form-select">
                <option value="" disabled>Selecciona una opción</option>
                <option v-for="p in proyectos" :key="p.id" :value="p.id">{{ p.nombre }}</option>
                <option value="otro">Otro</option>
              </select>
            </div>
            <p v-if="errores.proyecto" class="rf-form-error">{{ errores.proyecto }}</p>
          </div>
          <!-- Campo trampa: fuera de pantalla y sin foco; sólo un bot lo llena. -->
          <div class="rf-form-trampa" aria-hidden="true">
            <label for="rf-sitio-web">Sitio web</label>
            <input
              id="rf-sitio-web"
              v-model="form.sitio_web"
              type="text"
              name="sitio_web"
              tabindex="-1"
              autocomplete="off"
            >
          </div>
          <p v-if="error" class="rf-form-error">{{ error }}</p>
          <button type="submit" class="rf-btn rf-form-submit" :disabled="enviando">
            {{ enviando ? 'Enviando…' : 'Enviar solicitud de contacto' }}
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { ASSETS } from './formato';
import { enviarContacto, listarProyectos } from '@/services/refugiosApi';

export default {
  name: 'RfContacto',
  props: {
    proyecto: { type: Number, default: null },
  },
  data() {
    return {
      ASSETS,
      proyectos: [],
      form: { nombre: '', correo: '', telefono: '', proyecto: this.proyecto || '', sitio_web: '' },
      errores: {},
      error: '',
      enviando: false,
      enviado: '',
    };
  },
  async mounted() {
    try {
      this.proyectos = await listarProyectos();
    } catch (e) {
      this.error = 'No se pudo cargar la lista de proyectos; puedes elegir "Otro".';
    }
  },
  methods: {
    async enviar() {
      this.errores = {};
      this.error = '';
      this.enviando = true;
      try {
        await enviarContacto(this.form);
        this.enviado = this.form.nombre.trim().split(' ')[0];
      } catch (e) {
        const status = e.response && e.response.status;
        const datos = e.response && e.response.data;
        if (status === 429) {
          this.error = 'Recibimos varias solicitudes desde tu conexión. Intenta de nuevo en una hora.';
        } else if (datos && datos.errores) {
          this.errores = datos.errores;
        } else {
          this.error = (datos && datos.error) || 'No se pudo enviar la solicitud. Intenta de nuevo en un momento.';
        }
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>
